"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useDeepMemo_1 = require("../../hooks/useDeepMemo");
const useFetch_1 = __importDefault(require("../../hooks/useFetch"));
const common_styled_components_1 = require("../common-styled-components");
const ToolLayout_1 = __importDefault(require("../custom/ToolLayout"));
const useMetadata_1 = require("../../hooks/useMetadata");
const VoyageSelectionPanel_1 = __importDefault(require("./VoyageSelectionPanel"));
const EnergySourceSelectionPanel_1 = __importDefault(require("../custom/EnergySourceSelectionPanel"));
const VoyageResults_1 = __importDefault(require("./VoyageResults"));
const styled_components_1 = __importDefault(require("styled-components"));
const ToggleableContent_1 = require("../generic/ToggleableContent");
const lodash_1 = require("lodash");
const useMergedCalculatorState_1 = require("../../hooks/useMergedCalculatorState");
const calculatorUtils_1 = require("../../util/calculatorUtils");
const apiUtils_1 = require("../../util/apiUtils");
const auth_1 = require("../../util/auth");
const SubmitButton = ({ onClick, disabled, }) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: onClick, disabled: disabled, children: "Submit" }));
const SubmitContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
exports.default = () => {
    const [voyageParams, setVoyageParams, removeComparison] = (0, useMergedCalculatorState_1.useMergedCalculatorState)();
    const [previousParams, setPreviousParams] = (0, react_1.useState)();
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const [hasDoneInitialLoad, setHasDoneInitialLoad] = (0, react_1.useState)(false);
    // Init params from metadata
    (0, react_1.useEffect)(() => {
        if (metadata && voyageParams === undefined) {
            const engine = 1;
            const fuel = 1;
            setVoyageParams({
                emission_allowance_price: 90,
                imo_number: 9590838,
                ship_type: 0,
                draft: 11,
                ballast: false,
                season: 2,
                speed: 12,
                departure_port: "SGSIN",
                departure_port_label: "Singapore (SGSIN)",
                destination_port: "NLRTM",
                destination_port_label: "Rotterdam (NLRTM)",
                disabled_canals: [],
                disabled_passages: [],
                fuels: [
                    {
                        fuel_price: metadata.fuels[fuel].price,
                        engine_type: engine,
                        engine_efficiency: metadata["efficiency-fuel-engine"][fuel][engine],
                        fuel_type: fuel,
                    },
                ],
                comparison_fuels: [(0, calculatorUtils_1.getInitialComparisonFuelParam)(metadata)],
            });
        }
    }, [metadata]);
    const { getAuthHeader } = (0, auth_1.useAuthentication)();
    const [voyageCalculation, _setUrl, setBody] = (0, useFetch_1.default)("calculator/voyage", undefined, true);
    const [canCalculate] = (0, useDeepMemo_1.useDeepMemo)(() => metadata && voyageParams
        ? [(0, calculatorUtils_1.canCreateCalculation)(voyageParams, metadata)]
        : [false], [voyageParams, metadata]);
    const [validationErrors] = (0, useDeepMemo_1.useDeepMemo)(() => metadata && voyageParams
        ? [(0, calculatorUtils_1.getCalculationValidationErrors)(voyageParams, metadata)]
        : [[]], [voyageParams, metadata]);
    (0, react_1.useEffect)(() => {
        if (canCalculate &&
            !hasDoneInitialLoad &&
            !(0, lodash_1.isEqual)(previousParams, voyageParams)) {
            setHasDoneInitialLoad(true);
            setBody(JSON.stringify(voyageParams));
            setPreviousParams(voyageParams);
        }
    }, [voyageParams, previousParams, canCalculate]);
    const onSubmit = (e) => {
        e.preventDefault();
        if (canCalculate && !(0, lodash_1.isEqual)(previousParams, voyageParams)) {
            setPreviousParams(voyageParams);
            setBody(JSON.stringify(voyageParams));
        }
    };
    // Data logging
    // console.info("params", calculatorParams);
    // console.info(
    //   voyageCalculation.status === LoaderStatus.Success
    //     ? "Results: " + JSON.stringify(voyageCalculation.data, undefined, 2)
    //     : "loading"
    // );
    // console.info(
    //   metadata.status === LoaderStatus.Success
    //     ? "Metadata: " + JSON.stringify(metadata.data, undefined, 2)
    //     : "loading"
    // );
    const [languageData] = (0, useFetch_1.default)("calculator/language/en", undefined);
    const texts = languageData.status === apiUtils_1.LoaderStatus.Success
        ? languageData.data
        : undefined;
    const submitIsDisabled = (0, lodash_1.isEqual)(previousParams, voyageParams) || !canCalculate;
    const errorMessage = !canCalculate && validationErrors && validationErrors.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("ul", { style: { marginLeft: "20px" }, children: validationErrors.map((error, index) => ((0, jsx_runtime_1.jsx)("li", { style: { marginBottom: "8px" }, children: error }, index))) }) })) : !canCalculate ? ("Select a comparison energy source with a lower intensity than the current energy source.") : null;
    const selections = metadata && voyageParams && texts ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.TitleWithExtraContent, { titleLevel: "Section", extraContent: (0, jsx_runtime_1.jsx)(SubmitButton, { onClick: onSubmit, disabled: submitIsDisabled }), children: "Voyage options" }), (0, jsx_runtime_1.jsx)(VoyageSelectionPanel_1.default, { title: "", initialParams: (0, lodash_1.omit)(voyageParams, "comparison_fuels", "fuels"), metadata: metadata, setParams: setVoyageParams, texts: texts }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: "Energy source options" }), (0, jsx_runtime_1.jsx)(EnergySourceSelectionPanel_1.default, { title: "Fossil fuel", isComparison: false, useFOC: false, initialParams: voyageParams.fuels[0], metadata: metadata, setParams: setVoyageParams, fuelIndex: 0, texts: texts }), (0, jsx_runtime_1.jsx)(EnergySourceSelectionPanel_1.default, { title: "Low-carbon energy source", isComparison: true, useFOC: false, initialParams: voyageParams.comparison_fuels[0], metadata: metadata, setParams: setVoyageParams, fuelIndex: 0, texts: texts }), (0, jsx_runtime_1.jsx)(ToggleableContent_1.ToggleableContent, { buttonTitle: "Add", closeText: "Remove", onClose: () => removeComparison(true, 1), onOpen: () => setVoyageParams({
                    comparison_fuels: [
                        voyageParams.comparison_fuels[0],
                        (0, calculatorUtils_1.getInitialSecondComparisonFuelParam)(metadata),
                    ],
                }), children: (0, jsx_runtime_1.jsx)(EnergySourceSelectionPanel_1.default, { title: "Second low-carbon energy source", isComparison: true, useFOC: false, initialParams: voyageParams.comparison_fuels[1], metadata: metadata, setParams: setVoyageParams, fuelIndex: 1, texts: texts }) }), (0, jsx_runtime_1.jsx)(SubmitContainer, { children: (0, jsx_runtime_1.jsx)(SubmitButton, { onClick: onSubmit, disabled: submitIsDisabled }) })] })) : (texts && (0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: texts.loading_options }));
    const results = !canCalculate && texts ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.P, { style: { height: "600px" }, children: errorMessage })) : voyageParams &&
        previousParams &&
        voyageCalculation?.status === apiUtils_1.LoaderStatus.Success &&
        voyageCalculation.data?.comparisons &&
        voyageCalculation.data.comparisons.length > 0 &&
        metadata &&
        texts ? ((0, jsx_runtime_1.jsx)(VoyageResults_1.default, { params: previousParams, fuelTypes: metadata.fuels, calculation: voyageCalculation.data, metadata: metadata, texts: texts })) : voyageCalculation?.status === apiUtils_1.LoaderStatus.Idle ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.TextContent, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.P, { style: { height: "600px" }, children: "Submit new voyage options to create a calculation." }) })) : (texts && ((0, jsx_runtime_1.jsx)(common_styled_components_1.TextContent, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.P, { style: { height: "600px" }, children: "Loading results\u2026 Please allow for up to 30 seconds of waiting time." }) })));
    return texts ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: (0, jsx_runtime_1.jsx)(ToolLayout_1.default, { intro: "", selections: selections, results: results }) })) : ((0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, {}));
};
